import { StatusName } from '@range.io/basic-types'
import { taggedSum } from '@range.io/functional'
import { ReduxActions } from '../../redux'
import CommandPlayer from './command-player'

const StatusNameChangedCommand = taggedSum('StatusNameChangedCommand', {
    Inbound: {
        statusName: 'StatusName',
    },
})

const runInboundCommand = (resources, command) => {
    const { dispatch } = resources
    const { statusName } = command
    dispatch(ReduxActions.statusNameAdded(statusName))
    dispatch(ReduxActions.updateStatusNameInFilterSettings({ statusName }))
}

const addCommand = (addCommandToHistory, registerCommandPlayer) => {
    registerCommandPlayer(
        StatusNameChangedCommand,
        CommandPlayer({
            CommandType: StatusNameChangedCommand,
            Type: StatusName,
            collectionPath: projectId => `/projects/${projectId}/statusNames/`,
            runInboundCommand,
            runOutboundCommand: () => {},
            addCommandToHistory,
            changeType: 'modified',
        })
    )
}

export { addCommand, StatusNameChangedCommand }
